import React, { memo, useMemo } from "react";
import { css } from "@linaria/core";
import cx from "classnames";
import Text from "@ui/Text";
import { FAULT_STATUS_DESCRIPTIONS, QUANTITY_VALUE_VALIDITY } from "./utils/status";
import { colors, spacings } from "@ui/Theme";
import type { Series } from "./utils/options";
import { definePointMarker } from "./utils/options";
import { styled } from "@linaria/react";
import { groupBy } from "diagnostics-lib/iterable";
const TimeserieDisplayLegendContainer = css`
  display: flex;
  gap: ${spacings.s};
  justify-content: end;
  color: ${colors.carbon800};
  padding-right: ${spacings.xs};
`;

const TimeserieDisplayLegendItem = css`
  display: flex;
  align-items: center;
  gap: ${spacings.xs};
`;

const Marker = styled.span<{
  fillColor?: string;
  lineColor?: string;
  lineWidth?: number;
  symbol?: string;
}>`
  width: 8px;
  height: 8px;
  border-radius: ${props => (props.symbol === "circle" ? "5px" : "unset")};
  transform: rotateZ(${props => (props.symbol === "diamond" ? "45deg" : "0deg")});
  border-color: ${props => props.lineColor ?? props.fillColor ?? colors.carbon900};
  border-width: ${props => (props.lineWidth ?? 0) / 2}px;
  border-style: solid;
  background: ${props => props.fillColor ?? colors.carbon900};
  flex-shrink: 0;
  display: block;

  &.Marker--fault {
    filter: saturate(0.2);
  }
`;

export const TimeserieDisplayLegend = memo(({ series }: { series: Series[] }) => {
  const customDiscriminants = series.map(({ custom }) => custom.discriminant);
  const groupedDiscriminants = groupBy(customDiscriminants, d => d.serieColor);
  const discriminants = useMemo(
    () =>
      series
        .map(({ custom }) => custom.discriminant)
        .reduce(
          (acc, d) => {
            if (!d.column || !d.values.length) return acc;

            for (const value of d.values) {
              if (!acc[value]) {
                acc[value] =
                  d.serieColor && groupedDiscriminants.size === 1
                    ? { column: d.column, color: d.serieColor ?? colors.raw.titanium600 }
                    : { column: d.column, color: colors.raw.titanium600 };
                continue;
              }
              //   if (acc[value]?.color === d.serieColor && series.length === 1) continue;
              //   if (!acc[value]) {
              //     acc[value] = { column: d.column, color: d.serieColor ?? colors.raw.titanium600 };
              //     continue;
              //   }
              //   acc[value] = { column: d.column, color: colors.raw.titanium600 };
            }
            return acc;
          },
          {} as Record<string, { column: string; color: string }>,
        ),
    [groupedDiscriminants.size, series],
  );

  return (
    <div className={cx(TimeserieDisplayLegendContainer)}>
      {Object.entries(discriminants).map(([value, { column, color }]) => (
        <Text
          key={`${column}-${value}`}
          type="body2SemiBold"
          className={TimeserieDisplayLegendItem}
        >
          {column && (
            <Marker
              {...definePointMarker("", column, value, color)}
              className={cx({ "Marker--fault": column === "faultStatus" })}
            />
          )}
          {column === "validity" && QUANTITY_VALUE_VALIDITY[`${value}`]}
          {column === "faultStatus" && FAULT_STATUS_DESCRIPTIONS[`${value}`]}
          {column !== "validity" && column !== "faultStatus" && value}
        </Text>
      ))}
    </div>
  );
});
